import { Button } from "@components/atoms/Button"
import { Dropdown } from "@components/atoms/Dropdown"
import { createGravityFormComponent, GravityFormData, useGravityForm } from "eddev/integrations/gravityforms"
import { AnimatePresence, motion } from "motion/react"

const GravityFormRenderer = createGravityFormComponent({
  formComponents: {
    Select(props) {
      const { choices, placeholder, value, ...rest } = props
      return (
        <Dropdown
          className="w-full"
          options={props.choices.map((choice) => ({ label: choice.text, value: choice.value }))}
          {...rest}
          // label={placeholder}
          value={value as string}
        />
      )
    },
    SubmitBar(props) {
      return (
        <div className="flex justify-between pt-4">
          {props.canGoBack && (
            <Button type="button" onClick={props.goBack}>
              Go Back
            </Button>
          )}
          <div />
          <Button type="submit">{props.label}</Button>
        </div>
      )
    },
    Form(props) {
      return (
        <form onSubmit={props.onSubmit} className="edgf-form">
          <AnimatePresence initial={false} mode="wait">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              key={props.layout.type === "page" ? "page-" + props.layout.page : props.layout.type}
            >
              {!!props.state.pageInfo?.title && (
                <h2 className="type-title-xs-caps mb-4">{props.state.pageInfo?.title}</h2>
              )}
              {props.children}
            </motion.div>
          </AnimatePresence>
        </form>
      )
    },
  },
  fieldComponents: {
    multi_choice(props) {
      return <props.Wrapper>{JSON.stringify(props.choices)}</props.Wrapper>
    },
    // select(props) {
    //   return (
    //     <props.Wrapper>
    //       <Dropdown
    //         className="w-full"
    //         options={props.choices.map((choice) => ({ label: choice.text, value: choice.value }))}
    //         onChange={(e) => props.set(e.currentTarget.value)}
    //         value={props.value}
    //       />
    //     </props.Wrapper>
    //   )
    // },
  },
})

type Props = {
  form: GravityFormData
  prepopulate?: {
    [key: string]: any
  }
}

export function GravityForm(props: Props) {
  props.form.fields = props.form.fields.filter((field) => field.type !== "page")
  const state = useGravityForm(props)
  return <GravityFormRenderer state={state} />
}
